import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card guide" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "快速找到運動場地", -1)
const _hoisted_3 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.$style.directions, _ctx.isTouched && _ctx.$style.snap]),
        style: _normalizeStyle({ gridTemplateColumns: `repeat(${_ctx.content.length + 1},100%)` }),
        ref: "wrap",
        onTouchstart: _cache[0] || (_cache[0] = () => (_ctx.isTouched = true)),
        onScroll: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isTouched && _ctx.scrollFunc()))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.$style.piece])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.coverImage)
          }, [
            _createElementVNode("div", null, [
              _createVNode(_component_Logo),
              _hoisted_2
            ])
          ], 2)
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content, (slide, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(_ctx.$style.piece)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.image)
            }, [
              _createElementVNode("img", {
                src: slide.image,
                alt: slide.title
              }, null, 8, _hoisted_3)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.description)
            }, [
              _createElementVNode("h2", null, _toDisplayString(slide.title), 1),
              _createElementVNode("p", null, _toDisplayString(slide.text), 1)
            ], 2)
          ], 2))
        }), 128))
      ], 38),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.switch)
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.$style.skip),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, "跳過", 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.stepBtn),
          style: _normalizeStyle({ opacity: _ctx.step > 0 ? '1' : '0' })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.length, (num) => {
            return (_openBlock(), _createElementBlock("span", {
              key: num,
              style: _normalizeStyle({ opacity: _ctx.step === num ? '1' : '0.4' })
            }, null, 4))
          }), 128))
        ], 6),
        _createVNode(_component_Button, {
          class: _normalizeClass(_ctx.$style.dirBtn),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchStep())),
          btnName: "Arrow",
          btyType: "fillBtn",
          title: "下一步",
          fillBtn: ""
        }, null, 8, ["class"])
      ], 2)
    ])
  ]))
}